import { render, staticRenderFns } from "./OfferHistoryNew.vue?vue&type=template&id=6d6c098a&scoped=true"
import script from "./OfferHistoryNew.vue?vue&type=script&lang=ts"
export * from "./OfferHistoryNew.vue?vue&type=script&lang=ts"
import style0 from "./OfferHistoryNew.vue?vue&type=style&index=0&id=6d6c098a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6c098a",
  null
  
)

export default component.exports